import { Common } from '../../../shared/Common';
import {
  tooltipBackgroundColor,
  tooltipBorderBottomColor,
  tooltipBorderColor,
  tooltipBoxShadow,
  tooltipColor,
} from './colors';

interface FinancialTooltipProps {
  active?: boolean;
  payload?: readonly any[];
  label?: string | number;
  isWeekly: boolean;
  includeTaxes?: boolean;
  groupByYears: boolean;
  expensesColor: string;
  incomeColor: string;
  balanceColor: string;
  taxColor: string;
}

const FinancialTooltip = ({
  active,
  payload,
  label,
  isWeekly,
  includeTaxes,
  groupByYears,
  expensesColor,
  incomeColor,
  balanceColor,
  taxColor,
}: FinancialTooltipProps) => {
  if (active && payload && payload.length) {
    const totalExpense = payload.find((p) => p.dataKey === 'totalExpense');
    const totalIncome = payload.find((p) => p.dataKey === 'totalIncome');
    const balance = payload.find((p) => p.dataKey === 'balance');
    const tax = payload.find((p) => p.dataKey === 'totalTax');

    let header = '';
    if (isWeekly) {
      if (groupByYears) {
        header = `Tydzień ${label}`;
      } else {
        const year = payload[0].payload.year;
        const week = payload[0].payload.week;
        header = `Tydzień ${week}, ${year}`;
      }
    } else {
      label = payload[0].payload.month;
      if (label!.toString().length <= 1) {
        label = '0' + label;
      }
      const year = payload[0].payload.year;
      header = `${label}.${year}`;
    }

    return (
      <div
        style={{
          backgroundColor: tooltipBackgroundColor,
          border: `1px solid ${tooltipBorderColor}`,
          borderRadius: '4px',
          padding: '8px 12px',
          boxShadow: tooltipBoxShadow,
        }}
      >
        <div
          style={{
            fontSize: '13px',
            fontWeight: 'bold',
            color: tooltipColor,
            marginBottom: '6px',
            borderBottom: `1px solid ${tooltipBorderBottomColor}`,
            paddingBottom: '4px',
          }}
        >
          {header}
        </div>
        {totalExpense && (
          <div style={{ fontSize: '12px', color: expensesColor, marginBottom: '3px' }}>
            <span style={{ fontWeight: '500' }}>Wydatki:</span>{' '}
            {Common.Utils.getCurrencyString(Number(totalExpense.value))}
          </div>
        )}
        {totalIncome && (
          <div style={{ fontSize: '12px', color: incomeColor, marginBottom: '3px' }}>
            <span style={{ fontWeight: '500' }}>{includeTaxes ? 'Przychód:' : 'Dochód:'}</span>{' '}
            {Common.Utils.getCurrencyString(Number(totalIncome.value))}
          </div>
        )}
        {balance && (
          <div style={{ fontSize: '12px', color: balanceColor, marginBottom: '3px' }}>
            <span style={{ fontWeight: '500' }}>Bilans:</span> {Common.Utils.getCurrencyString(Number(balance.value))}
          </div>
        )}
        {tax && (
          <div style={{ fontSize: '12px', color: taxColor, marginBottom: '3px' }}>
            <span style={{ fontWeight: '500' }}>Podatek:</span> {Common.Utils.getCurrencyString(Number(tax.value))}
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default FinancialTooltip;
